import React from 'react'

const Instagram = () => {
  return (
    <div className="text-6xl font-bold">
        Instagram
    </div>
  )
}

export default Instagram